import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useChat } from "@/contexts/ChatContext";
import { cn } from "@/lib/utils";
import { Sparkles } from "lucide-react";

/**
 * Dialog shown when user attempts to use premium features without a subscription
 */
export default function PremiumToolsDialog() {
  const { isPremiumDialog, setIsPremiumDialog, handleUpgrade } = useChat();

  return (
    <Dialog open={isPremiumDialog} onOpenChange={setIsPremiumDialog}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center">
            <Sparkles className="h-5 w-5 mr-2 text-yellow-500" />
            Premium Feature
          </DialogTitle>
          <DialogDescription>
            This assistant uses premium tools that require an upgraded account.
          </DialogDescription>
        </DialogHeader>

        <div className="py-4">
          <div
            className={cn(
              "rounded-lg border p-4 mb-4",
              "bg-yellow-50 border-yellow-200 dark:bg-yellow-950 dark:border-yellow-800"
            )}
          >
            <h3 className="font-medium mb-2 flex items-center">
              <Sparkles className="h-4 w-4 mr-2 text-yellow-500" />
              Premium Tools Include:
            </h3>
            <ul className="space-y-1 text-sm list-disc pl-5">
              <li>Advanced Data Analysis</li>
              <li>Chart & Graph Generation</li>
              <li>PDF/CSV Document Creation</li>
              <li>Web Search & API Integration</li>
              <li>Advanced Code Interpreters</li>
            </ul>
          </div>

          <p className="text-sm text-muted-foreground">
            Upgrade to unlock all premium features and tools for enhanced
            productivity.
          </p>
        </div>

        <DialogFooter className="flex sm:justify-between">
          <DialogClose asChild>
            <Button variant="outline">Continue with Basic</Button>
          </DialogClose>
          <Button
            onClick={handleUpgrade}
            className="bg-gradient-to-r from-indigo-500 to-purple-500 hover:from-indigo-600 hover:to-purple-600"
          >
            <Sparkles className="h-4 w-4 mr-2" />
            Upgrade Now
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
